import { useEffect } from 'react';

import { useCreateRoomShareLinkMutation } from '~teacher/hook/room';
import { useRoomDetail } from '~teacher/hook/room/useRoomDetail';

/**
 * The legacy Python API doesn't always have share urls
 * @param roomId
 */
export function useGenerateShareUrl(roomId: number) {
  const roomDetail = useRoomDetail({
    roomId: roomId,
  });
  const createRoomShareLinkMutation = useCreateRoomShareLinkMutation();
  const roomName = roomDetail.data?.name;
  const roomUrl = roomDetail.data?.url;
  const roomDetailIsSuccess = roomDetail.isSuccess;

  useEffect(() => {
    if (createRoomShareLinkMutation.isError) return;
    if (!roomDetailIsSuccess) return;
    if (roomUrl) return;
    if (!createRoomShareLinkMutation.isIdle) return;

    createRoomShareLinkMutation.mutate({
      roomName: roomName,
      roomId: roomId,
    });
  }, [
    createRoomShareLinkMutation,
    roomName,
    roomUrl,
    roomDetailIsSuccess,
    roomId,
  ]);
}
